<template>

  <div>
    <div class="hit-text-left hit-form-group">
      <a href="#" class="hit-btn hit-btn-default hit-btn-xs hit-btn-block" v-on:click.prevent="function(){open = !open; }">{{ getBtnLabel() }}</a>
    </div>

    <transition name="fade">
      <div class="hit-row" v-bind:key="open" v-if="open">
        <div class="hit-col-md-12">
          <div class="hit-panel hit-panel-default">
            <div class="hit-panel-heading" v-html="$t('message.comment')+' ('+$t('message.public')+')'" />
            <div class="hit-form-group" spellcheck="false">
              <ckeditor id="comment" :editor="editor" v-model="comment" :config="editorConfig"></ckeditor>
            </div>
          </div>
        </div>



      </div>
    </transition>
  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/de'
import md5 from 'js-md5'



export default{

  props: {entry: Object, callback: Function},

  data () {
    return {
      mail_send: false,
      open: false,
      comment: this.entry.adminComment,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'bold', 'italic', 'link' ],
        language: 'de',
        config: {enterMode: ClassicEditor.ENTER_BR}
      }
    }
  },

  watch:{

    comment: function(val){  this.entry.adminComment = val; this.callback(this.entry); this.$store.dispatch("set_admin_comment", {data: this.entry.adminComment, user: this.$store.getters.user.md5_id, board: this.entry.board.ID, ID: this.entry.ID }); }
  },

  methods: {

    getBtnLabel() {

      if( this.entry.adminComment )
        return this.$t("message.edit", {name: this.$t("message.comment")})
      else
        return this.$t("message.add", {name: this.$t("message.comment")})
    }
  }

}

</script>
